import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { cancel_run_chat_messages_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';

import { SimpleResponse } from '@/types/common.ts';

type props = {
  run_id: string;
};

const useCancelChatMessage = (
  options?: UseMutationOptions<SimpleResponse, AxiosError, props>,
): UseMutationResult<SimpleResponse, AxiosError, props> => {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: async ({ run_id }: props) => {
      const response = await apiClient.put<SimpleResponse>(cancel_run_chat_messages_url(run_id));

      return response.data;
    },
    ...options,
  });
};

export default useCancelChatMessage;
